module.exports = __webpack_public_path__ + "static/media/12UNCTAD18.4b06d15b.jpg";